import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const JobStatus = lazy(() => import('modules/admin/master/JobStatus'));

const JobStatusPage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <JobStatus />
    </Suspense>
  </AdminLayout>
);

export default JobStatusPage;
